import { getBackendUrl } from "@Utils";
import { useEffect, useState, useRef, forwardRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ToolTipComponent from "../../cubeComponent/html/tooltip";
import { CONVERSION_STATUS_MAPPER } from "../../services/constants";
import { BiSolidPlusCircle } from "react-icons/bi";
import { PiDotsThreeCircleFill } from "react-icons/pi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import axiosWrapper from "@Services/axiosWrapper";

const FileConversionStatus = forwardRef((props, ref) => {
  const [conversionStatus, setConversionStatus] = useState(props.conversionStatus);
  const [tooltipContent, setTooltipContent] = useState("");
  const pollingRef = ref || useRef(null); // Ref to store the timeout ID
  const isMounted = useRef(true); // Track if the component is mounted

  useEffect(() => {
    isMounted.current = true;
    setTooltipContent(CONVERSION_STATUS_MAPPER[conversionStatus]);
    startPolling(conversionStatus);

    return () => {
      isMounted.current = false;
      if (pollingRef.current) {
        clearTimeout(pollingRef.current); // Clear any pending timeout
      }
    };
  }, [conversionStatus]);

  const startPolling = (currentStatus) => {
    if (!["IN_PROGRESS", "NOT_STARTED"].includes(currentStatus)) return;

    pollingRef.current = setTimeout(async () => {
      if (!isMounted.current) return;

      try {
        const response = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/getFileVersionData`, {
          fileVersionId: props.fileVersion,
        });

        if (isMounted.current) {
          setConversionStatus(response.data.data.conversionStatus);
          startPolling(response.data.data.conversionStatus);
        }
      } catch (error) {
        console.error("Error fetching file version data:", error);
      }
    }, 10000);
  };

  return (
    <ToolTipComponent showTipPointer position="bottom" content={tooltipContent} style={{ display: "inline-flex" }}>
      {["RETRY", "IN_PROGRESS"].includes(conversionStatus) && <CircularProgress disableShrink size={16} />}
      {conversionStatus === "ERRORED" && (
        <BiSolidPlusCircle style={{ transform: "rotate(45deg)" }} color="var(--negative-communication)" size={16} />
      )}
      {conversionStatus === "COMPLETED" && <IoIosCheckmarkCircle color="var(--positive-communication)" size={16} />}
      {conversionStatus === "NOT_STARTED" && <PiDotsThreeCircleFill color="var(--primary-gradient-color2)" size={16} />}
    </ToolTipComponent>
  );
});
FileConversionStatus.displayName = "FileConversionStatus";
export default FileConversionStatus;
